module.exports = __webpack_public_path__ + "img/Arbitrum.709c126a.svg";